export const APP_KEYS = ["backpack", "ubin_portal"] as const;

export type AppKey = (typeof APP_KEYS)[number];

type AppManifestEntry = {
  title: string;
  description: string;
  faviconPath: string;
  webManifestPath: string;
  themeStylesheetPath: string;

  // TBD: per-app share image for the og:image link-preview card. Also needs the image assets
  // plus an `%APP_OG_IMAGE%` token in `appHtmlPlugin` (vite.config.mts) and the tag in
  // index.html
  // ogImagePath: string;

  // Module the `@app-root` alias resolves to - see `resolve.alias` in `vite.config.mts`.
  appRootPath: string;
};

export const APP_MANIFEST = {
  backpack: {
    title: "Backpack",
    description:
      "Backpack is the single source of truth for compliance and reporting in commercial real estate.",
    faviconPath: "/src/favicons/backpack-favicon-32x32.png",
    // ogImagePath: "/src/og-images/backpack-og-image.png",
    webManifestPath: "/manifest.backpack.json",
    themeStylesheetPath: "/src/backpack-console/theme.css",
    appRootPath: "src/backpack-console/BackpackAppRoot.tsx",
  },
  ubin_portal: {
    title: "UBIN™ Portal",
    description:
      "Look up a building by UBIN™ or address to explore its location and footprint.",
    faviconPath: "/src/favicons/ubin-portal-favicon-32x32.png",
    // ogImagePath: "/src/og-images/ubin-portal-og-image.png",
    webManifestPath: "/manifest.ubin-portal.json",
    themeStylesheetPath: "/src/ubin-portal/theme/theme.css",
    appRootPath: "src/ubin-portal/UbinPortalAppRoot.tsx",
  },
} satisfies Record<AppKey, AppManifestEntry>;
